import { Pipe, PipeTransform } from '@angular/core';

import { AutocompletePlaces } from '@search-bar/entities/autocomplete-places';
import { AutocompletePlace } from '@app/modules/shared/base-search-bar/entities/autocomplete';

@Pipe({
  name: 'autocompleteVm',
  standalone: false
})
export class AutocompleteVmPipe implements PipeTransform {

  constructor() { }

  transform(autocompletePlaces: AutocompletePlaces): AutocompletePlaces {
    return {
      cities: autocompletePlaces.cities.filter(this.filterAutocomplete),
      airports: autocompletePlaces.airports.filter(this.filterAutocomplete)
    };
  }

  private filterAutocomplete(place: AutocompletePlace): boolean {
    const onlyLetters = /^[a-zA-Z]+$/;
    return !place.code.includes('_') && onlyLetters.test(place.code);
  }
}
